import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from './../../../constants';

@Injectable()
export class ProposalApproverService {

  constructor(private http: Http) { }

  private apiUrl = globalConst.baseAPI;
  
  getProfile(){
    return this.http
		.get(this.apiUrl + "profile/v1/getprofiles?$orderby=Descricao", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
  }
	
	
	///flowlimitrelease/v1/getlimit?$orderby=Nivel&$filter=SegmentoID eq guid'933EE1F2-98A8-4C9E-AB20-187D427D2D18' and Ativo eq true
  getApprovers(segmentID){
    return this.http
		.get(this.apiUrl + "/flowlimitrelease/v1/getlimit?$orderby=Nivel&$filter=SegmentoID eq guid'"+segmentID+"' and Ativo eq true", JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}
	
	
	getSegments(){
		return this.http
			.get(this.apiUrl + "/segments/v1/segments/?$filter=Ativo&$orderby=Descricao asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	insertApprover(approverObj){	
	return this.http
	.post(this.apiUrl + "/flowlimitrelease/v1/insertlimit", approverObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
	.map((res: Response) => res.json()).catch(e => {
		if (e.status === 401) {
			return Observable.throw('Unauthorized');
		}
	});
}

	removeApprover(approverID){
		return this.http
			.delete(this.apiUrl + "/flowlimitrelease/v1/inactivelimit/"+approverID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}

	updateApprover(updateObj){
		console.log(updateObj);
		return this.http
			.put(this.apiUrl + "/flowlimitrelease/v1/updatelimit/",updateObj, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json()).catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
	}
}



// WEBPACK FOOTER //
// ./src/app/proposal-approver/service/proposal-approver.service.ts